module.exports = __webpack_public_path__ + "common/icon-detail-7d6af055638f92f7ae5f6f292a5177bb.svg";